import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-multi-factor-authentification',
  templateUrl: './multi-factor-authentification.component.html',
  styleUrls: ['./multi-factor-authentification.component.scss']
})
export class MultiFactorAuthentificationComponent implements OnInit {
  public currentStep: number
  public lastStep = 3

  constructor(private router: Router) { 
    this.currentStep = 1;
  }

  nextStep(){
    if(this.currentStep==this.lastStep){
      this.router.navigate(['/home']);
    }
    this.currentStep++;
  }

  ngOnInit() {
  }

 

}
